// TYPES
import { ReducerAction } from 'store/modules/types';
import { Types } from './types';

export function iirgdClear(): ReducerAction {
	return {
		type: Types.IIRGD_CLEAR,
		payload: null,
	};
}
